import { Button } from '@workspace/ui/common';

interface AskGregSectionButtonProps {
  onClick: () => void;
}

export function AskGregSectionButton({ onClick }: AskGregSectionButtonProps) {
  return (
    <Button
      variant="primary"
      className="w-full md:w-auto"
      onClick={(e) => {
        e.preventDefault();
        onClick();
      }}
    >
      Ask Greg
    </Button>
  );
}
